import * as React from 'react';

import i18n from 'helper/i18n';

import { LinkProps } from 'components/atoms/Link';
import LinkList from 'components/molecules/LinkList';
import { template } from '../../../../helper/string';

export type ProgramInfoProps = {
	lead?: string;
	info?: string;
	isAuthenticated: boolean;
	userWeight?: number;
	contains: {
		calories?: number;
	};
	inactive?: boolean;
	support: {
		intro?: string;
		list?: Array<LinkProps>;
	};
};

export default class ProgramInfo extends React.Component<ProgramInfoProps> {
	public static defaultProps = {
		support: {},
		contains: {},
		auth: {},
		userWeight: 0,
	};

	public calculateEnergyBurn() {
		const { contains, userWeight } = this.props;

		const cals = contains ? contains.calories || 0 : 0;
		const anamnesisWeight = userWeight || 0;
		const amount = parseInt(`${cals * anamnesisWeight}`, 10);
		const diff = amount % 100;
		let add = 0;

		if (diff >= 50) {
			add = 100;
		}

		return amount - diff + add;
	}

	public getShoppingList() {
		const links = this.props.support.list || [];

		return links.map((link: LinkProps) => {
			return {
				...link,
				externalHref: link.href,
				href: void 0,
				onClick: void 0,
				icon: 'cart',
			};
		});
	}

	get hasSupportList(): boolean {
		const { support } = this.props;

		return !!(support && (support.list || []).length > 0);
	}

	public render() {
		const { lead, info, isAuthenticated, support } = this.props;

		const infoData = {
			energyValue: this.calculateEnergyBurn(),
			energyUnit: i18n('react.impulsCoach.components.ProgramInfo.energyUnitLabel'),
		};

		return (
			<div className="container">
				<div className="row">
					<div className="col-xs-12 col-md-9">
						<div className="m-program-info">
							<div className="m-program-info__head">
								<p className="m-program-info__lead" dangerouslySetInnerHTML={{ __html: lead! }} />
								{(isAuthenticated || this.hasSupportList) && (
									<h2 className="m-program-info__title">
										{i18n('react.impulsCoach.components.ProgramInfo.moreAboutProgram')}
									</h2>
								)}
							</div>

							<div className="m-program-info__content">
								{isAuthenticated && (
									<div className="m-program-info__box">
										{info && (
											<div
												className={'m-program-info__box-text m-program-info__box-text--cms'}
												dangerouslySetInnerHTML={{
													__html: template(info, infoData),
												}}
											/>
										)}
										{!info && (
											<p
												className={'m-program-info__box-text'}
												dangerouslySetInnerHTML={{
													__html: i18n(
														'react.impulsCoach.components.ProgramInfo.energyText',
														infoData
													),
												}}
											/>
										)}
									</div>
								)}
								{this.hasSupportList && (
									<div className="m-program-info__box">
										<p className="m-program-info__box-intro">
											{i18n('react.impulsCoach.components.ProgramInfo.toolsCaption')}
										</p>
										{support.list && <LinkList links={this.getShoppingList()} />}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
